var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2464 22H3.57974C2.10698 22 0.913076 20.8247 0.913086 19.375L0.913189 3.62499C0.913198 2.17525 2.1071 1 3.57986 1H15.5802C17.0529 1 18.2468 2.17526 18.2468 3.62501V8.87502M19.5798 20.0313L20.9131 21.3438M5.58017 6.25001H13.5802M5.58017 10.1875H13.5802M5.58017 14.125H9.58017M20.2464 17.4063C20.2464 19.2185 18.754 20.6876 16.9131 20.6876C15.0721 20.6876 13.5798 19.2185 13.5798 17.4063C13.5798 15.5941 15.0721 14.125 16.9131 14.125C18.754 14.125 20.2464 15.5941 20.2464 17.4063Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBot);
export default __webpack_public_path__ + "static/media/document-bot.512fd1b099fc91f64c66ac2e6c317dbb.svg";
export { ForwardRef as ReactComponent };